import React, { useEffect, useContext, useState } from "react";
import Navigation from "../../Components/Navigation";
import Footer from "../../Components/Footer";
import HeroAlt from "../../Components/HeroAlt";
import ScrollToTopButton from "../../Components/ScrollTop";
import CEisses from "../../Components/IssueCategories/CommunityEngagement";
import EDissues from "../../Components/IssueCategories/EconomicDevelopment";
import HCissues from "../../Components/IssueCategories/Healthcare";
import TRissues from "../../Components/IssueCategories/Transportation";
import YCissues from "../../Components/IssueCategories/YouthConcerns";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import {
  IconButton,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button, // Importing Button component
} from "@mui/material";

import ContactRibbon from "../../Components/ContactRibbon";

export default function Issues() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Key Issues";
  }, []);

  return (
    <main>
      <Navigation />
      <HeroAlt title="Our Key Issues" />
     

      <section>
     
        <Grid container size={{ xs: 12 }}>
          <Grid
            container
            size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
            justifyContent="center"
            backgroundColor="#f4f4f4"
            padding="2% 0"
            spacing={2}
          >
            {/* KEY ISSUES INTRO SECTION */}
            <Grid
              item
              size={{ xs: 11, sm: 11, md: 10, lg: 8, xl: 8 }}
              container
              justifyContent="start"
            >
           
              <Grid size={12} padding="1% 0">
                <p>
                  At Forward Focus, we’re dedicated to uplifting Eastern Alachua
                  County by gathering community input to drive meaningful
                  change. Through listening sessions and online comments,
                  residents have shared key challenges and opportunities in
                  community engagement, economic development, healthcare,
                  transportation, and youth concerns.
                </p>
                <p>
                  Below, you’ll find a breakdown of key issues by area. This
                  feedback helps shape county projects, programs, and
                  improvements that directly support our communities. If you
                  have additional input, we encourage you to share it through
                  our{" "}
                  <a className='comment-form-link' target="_blank" href="https://wkf.ms/4jlqDeG">
                    comment form
                  </a>
                  .
                </p>
               
              </Grid>
 
{/* 
              <Grid
                container
                size={{ xs: 12 }}
                spacing={3}
                justifyContent="left"
                marginBottom="4%"
                className="jump-link-container"
              >
                <Grid
                  container
                  item
                  size={{ xs: 12 }}
                  className="jump-link-title"
                >
                  <Typography fontWeight="bold" variant="h6">
                    Jump to Section
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 11, sm: 11, md: "auto" }}>
                  <Link href="/issues#engagement" className="jump-link">
                    Community Engagement
                  </Link>
                </Grid>
                <Grid item size={{ xs: 11, sm: 11, md: "auto" }}>
                  <Link href="/issues#development" className="jump-link">
                    Economic Development
                  </Link>
                </Grid>
                <Grid item size={{ xs: 11, sm: 11, md: "auto" }}>
                  <Link href="/issues#healthcare" className="jump-link">
                    Healthcare
                  </Link>
                </Grid>
                <Grid item size={{ xs: 11, sm: 11, md: "auto" }}>
                  <Link href="/issues#transportation" className="jump-link">
                    Transportation
                  </Link>
                </Grid>
                <Grid item size={{ xs: 11, sm: 11, md: "auto" }}>
                  <Link href="/issues#youthconcerns" className="jump-link">
                    Youth Concerns
                  </Link>
                </Grid>
              </Grid>
 */}
            </Grid>

            {/* Community Engagement Section */}
            <Grid
              container
              size={{ xs: 11, sm: 11, md: 10, lg: 8, xl: 8 }}
              id="engagement"
            >
              <ScrollToTopButton />
              <Grid mt={4}>
                <h3>Community Engagement</h3>
                <p>
                  For progress to be meaningful, residents must have a voice in
                  shaping their future. Many communities feel disconnected from
                  county resources and decision-making. Forward Focus works to
                  improve communication, amplify local voices, and expand
                  opportunities for youth engagement, recreation, and
                  community-building. By fostering trust and collaboration, we
                  can create stronger, more connected communities.
                </p>
              </Grid>
              <CEisses />
              <Grid size={{ xs: 12 }}>
                <ScrollToTopButton />
              </Grid>
            </Grid>

            {/* Economic Development Section */}
            <Grid
              container
              size={{ xs: 11, sm: 11, md: 10, lg: 8, xl: 8 }}
              id="development"
            >
              <Grid mt={4}>
                <h3>Economic Development</h3>
                <p>
                  Supporting local businesses and revitalizing commercial areas
                  are key to strengthening Eastern Alachua County’s economy.
                  Many communities struggle with vacant buildings, marketing
                  obstacles, and a lack of investment in tourism and local
                  industries. By fostering business growth, promoting unique
                  cultural and outdoor attractions, and encouraging smart
                  development, we can help communities prosper while preserving
                  their character.
                </p>
              </Grid>
              <EDissues />
            </Grid>

            {/* Healthcare Section */}
            <Grid
              container
              size={{ xs: 11, sm: 11, md: 10, lg: 8, xl: 8 }}
              id="healthcare"
            >
              <Grid mt={4}>
                <h3>Healthcare</h3>
                <p>
                  Access to quality healthcare is a challenge in many rural and
                  small-town areas. Residents often have to travel long
                  distances for medical services, and some communities lack
                  essential facilities like pharmacies, clinics, and senior care
                  options. Forward Focus works to identify solutions that bring
                  healthcare closer to residents, whether through mobile
                  services, satellite clinics, or expanded transportation
                  options. With this, we also aim to make healthcare and
                  insurance information more accessible and clear.
                </p>
              </Grid>
              <HCissues />
            </Grid>

            {/* Transportation Section */}
            <Grid
              container
              size={{ xs: 11, sm: 11, md: 10, lg: 8, xl: 8 }}
              id="transportation"
            >
              <Grid mt={4}>
                <h3>Transportation</h3>
                <p>
                  Safe and reliable transportation is essential for thriving
                  communities. Many areas in Eastern Alachua County face
                  challenges such as inconsistent traffic enforcement, limited
                  pedestrian infrastructure, and inadequate public
                  transportation options. Forward Focus aims to improve road
                  safety, enhance walkability, and ensure better communication
                  between local communities and the Department of
                  Transportation.
                </p>
              </Grid>
              <TRissues />
            </Grid>

            {/* Youth Concerns Section */}
            <Grid
              container
              size={{ xs: 11, sm: 11, md: 10, lg: 8, xl: 8 }}
              id="youthconcerns"
            >
              <Grid mt={4}>
                <h3>Youth Concerns</h3>
                <p>
                  The future of Eastern Alachua County lies within its youth,
                  making youth services, education, and the overall wellness of
                  eastern Alachua’s children and teen populations high
                  priorities for our initiative. Forward Focus aims to ensure
                  eastern Alachua’s communities have youth services and
                  opportunities present.
                </p>
              </Grid>
              <YCissues />
            </Grid>
          </Grid>
        </Grid>
      </section>

      {/* Contact Section */}
      <section className="contact-container">
        <ContactRibbon />
      </section>

      <Footer />
    </main>
  );
}
